import {
  ServiceRequestFieldPropsOption,
  ServiceRequestFieldType,
  ServiceRequestStep,
  ServiceRequestStepType,
} from '@domain/types';

export const jobTypeStep = (
  categories: ServiceRequestFieldPropsOption[],
): ServiceRequestStep => ({
  type: ServiceRequestStepType.DETAILS,
  inSummary: true,
  title: `quote:jobType.title`,
  additionalCopy: `quote:additionalCopy.jobType.title`,
  segmentEvent: `Job Type Selected`,
  fields: [
    {
      type: ServiceRequestFieldType.TILES,
      summaryTitle: `quote:jobType.summaryTitle`,
      props: {
        name: `category_id`,
        options: categories,
        validation: [`isRequired`],
      },
    },
  ],
});
